import { useState, useMemo } from 'react';

export function useParticipantState(participants: any[], initialId: string) {
    const [selectedParticipantId, setSelectedParticipantId] = useState(initialId);
    const selectedParticipant = useMemo(() =>
        participants.find(p => p.id === selectedParticipantId),
        [participants, selectedParticipantId]
    );

    return {
        selectedParticipantId,
        setSelectedParticipantId,
        selectedParticipant
    };
}

export function useFeedbackState() {
    const [expandedFeedback, setExpandedFeedback] = useState<Set<string>>(new Set());

    const toggleFeedback = (id: string) => {
        setExpandedFeedback(prev => {
            const next = new Set(prev);
            if (next.has(id)) {
                next.delete(id);
            } else {
                next.add(id);
            }
            return next;
        });
    };

    return {
        expandedFeedback,
        toggleFeedback
    };
}

export function useSimulationFilters() {
    // 기존 프로젝트처럼 최근 1개월 기준으로 디폴트 기간 설정
    const [startDate, setStartDate] = useState(() => {
        const oneMonthAgo = new Date();
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        oneMonthAgo.setHours(0, 0, 0, 0);
        return oneMonthAgo.toISOString().split('T')[0];
    });
    const [endDate, setEndDate] = useState(() => {
        const today = new Date();
        today.setHours(23, 59, 59, 999);
        return today.toISOString().split('T')[0];
    });
    const [sortCriteria, setSortCriteria] = useState('latest'); // latest, highest, lowest, all
    const [completionDates] = useState<string[]>([]); // API에서 가져온 날짜로 채워짐
    const [selectedCompletionDate, setSelectedCompletionDate] = useState('');

    return {
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        sortCriteria,
        setSortCriteria,
        completionDates,
        selectedCompletionDate,
        setSelectedCompletionDate
    };
}
